// 20 cities within ~2-hour drive of Memphis, TN. Sorted by metro proximity.
// Each city has SEO-targeted content + neighbor links for internal linking.

export const CITIES = [
  {
    slug: "memphis-tn",
    city: "Memphis",
    state: "TN",
    stateName: "Tennessee",
    county: "Shelby County",
    population: "≈ 633,000",
    drive: "Local",
    intro:
      "From Downtown to East Memphis, Whitehaven to Frayser, 901 Lots stripes and seals parking lots for retail centers, churches, apartment complexes, schools, and warehouses all across the city. We work after-hours and on weekends to keep your business open.",
    landmarks: [
      "Beale Street",
      "Overton Square",
      "Wolfchase Galleria area",
      "Poplar Corridor",
      "Memphis Medical District",
    ],
    services_focus: [
      "Retail plaza restriping",
      "Apartment complex sealcoating",
      "ADA compliance audits",
      "Warehouse striping",
    ],
    neighbors: ["germantown-tn", "bartlett-tn", "cordova-tn", "millington-tn", "west-memphis-ar"],
  },
  {
    slug: "germantown-tn",
    city: "Germantown",
    state: "TN",
    stateName: "Tennessee",
    county: "Shelby County",
    population: "≈ 41,000",
    drive: "20 min from Memphis",
    intro:
      "Germantown's retail centers, office parks, and HOA properties depend on clean, well-maintained parking lots. We deliver sharp lines, deep-black sealcoats, and code-compliant ADA work — without disrupting your tenants or weekend shoppers.",
    landmarks: ["Saddle Creek", "The Shops of Saddle Creek South", "Forest Hill-Irene Road"],
    services_focus: ["Office park striping", "HOA sealcoating", "Retail center restriping"],
    neighbors: ["collierville-tn", "memphis-tn", "cordova-tn", "bartlett-tn"],
  },
  {
    slug: "collierville-tn",
    city: "Collierville",
    state: "TN",
    stateName: "Tennessee",
    county: "Shelby County",
    population: "≈ 52,000",
    drive: "25 min from Memphis",
    intro:
      "Collierville is one of the fastest-growing communities in the Mid-South, and its commercial property owners expect polish. We provide clean striping, fresh sealcoat, and prompt restriping for retail, medical, and corporate properties.",
    landmarks: ["The Avenue Carriage Crossing", "Historic Town Square", "FedEx campus"],
    services_focus: ["Medical office striping", "Corporate campus sealcoating", "Retail restriping"],
    neighbors: ["germantown-tn", "olive-branch-ms", "cordova-tn"],
  },
  {
    slug: "bartlett-tn",
    city: "Bartlett",
    state: "TN",
    stateName: "Tennessee",
    county: "Shelby County",
    population: "≈ 57,000",
    drive: "25 min from Memphis",
    intro:
      "Bartlett's mix of retail, restaurants, churches, and schools keeps our crews busy year-round. From small church lots to large strip centers along Stage Road and Bartlett Boulevard, we deliver pavement work you'll be proud of.",
    landmarks: ["Bartlett Station", "Stage Road corridor", "Wolfchase area"],
    services_focus: ["Church parking striping", "Restaurant lot sealcoating", "School lot ADA"],
    neighbors: ["cordova-tn", "memphis-tn", "lakeland-tn", "arlington-tn"],
  },
  {
    slug: "cordova-tn",
    city: "Cordova",
    state: "TN",
    stateName: "Tennessee",
    county: "Shelby County",
    population: "≈ 70,000",
    drive: "20 min from Memphis",
    intro:
      "Cordova's commercial corridor along Germantown Parkway and Macon Road is one of the busiest in the metro. We schedule overnight and weekend crews so your tenants never miss a customer.",
    landmarks: ["Wolfchase Galleria", "Germantown Parkway", "Trinity Commons"],
    services_focus: ["Big-box retail striping", "Restaurant chain sealcoating", "Office park ADA"],
    neighbors: ["bartlett-tn", "germantown-tn", "memphis-tn", "lakeland-tn"],
  },
  {
    slug: "lakeland-tn",
    city: "Lakeland",
    state: "TN",
    stateName: "Tennessee",
    county: "Shelby County",
    population: "≈ 14,000",
    drive: "30 min from Memphis",
    intro:
      "Lakeland's expanding business district along U.S. 64 needs durable pavement work that holds up to growing traffic. We pair commercial-grade traffic paint with proper sealcoating to extend the life of every lot.",
    landmarks: ["Lakeland Commons", "U.S. 64 corridor", "Garner Lake"],
    services_focus: ["New construction layouts", "Retail striping", "Crack filling"],
    neighbors: ["arlington-tn", "bartlett-tn", "cordova-tn"],
  },
  {
    slug: "arlington-tn",
    city: "Arlington",
    state: "TN",
    stateName: "Tennessee",
    county: "Shelby County",
    population: "≈ 14,500",
    drive: "35 min from Memphis",
    intro:
      "Arlington is one of Shelby County's most rapidly growing towns. Its new commercial centers and schools need fresh, code-compliant striping the first time — we provide thoughtful layouts and durable markings.",
    landmarks: ["Arlington High School area", "Airline Road corridor"],
    services_focus: ["New layout design", "School lot striping", "Church sealcoating"],
    neighbors: ["lakeland-tn", "bartlett-tn", "millington-tn"],
  },
  {
    slug: "millington-tn",
    city: "Millington",
    state: "TN",
    stateName: "Tennessee",
    county: "Shelby County",
    population: "≈ 10,500",
    drive: "30 min from Memphis",
    intro:
      "Millington's industrial and military-adjacent properties demand pavement work that stands up to heavy use. We use heavy-duty sealer and traffic paint engineered for industrial-grade lots.",
    landmarks: ["NSA Mid-South", "Veterans Parkway", "Industrial Park"],
    services_focus: ["Industrial striping", "Heavy-duty sealcoating", "Pavement marking"],
    neighbors: ["arlington-tn", "memphis-tn", "bartlett-tn"],
  },
  {
    slug: "covington-tn",
    city: "Covington",
    state: "TN",
    stateName: "Tennessee",
    county: "Tipton County",
    population: "≈ 9,000",
    drive: "45 min from Memphis",
    intro:
      "Covington's downtown square and growing commercial belt along Highway 51 are home to local businesses that need reliable, affordable pavement work. We don't charge metro prices for Tipton County work.",
    landmarks: ["Tipton County Courthouse Square", "Highway 51 corridor"],
    services_focus: ["Small business striping", "Bank lot sealcoating", "Church lots"],
    neighbors: ["millington-tn", "memphis-tn"],
  },
  {
    slug: "jackson-tn",
    city: "Jackson",
    state: "TN",
    stateName: "Tennessee",
    county: "Madison County",
    population: "≈ 68,000",
    drive: "85 min from Memphis",
    intro:
      "As the largest city between Memphis and Nashville, Jackson is a regional commercial hub. We service the I-40 corridor, retail centers near North Highland, and commercial properties across Madison County.",
    landmarks: ["Old Hickory Mall area", "North Highland Avenue", "Casey Jones Village"],
    services_focus: ["Regional retail striping", "Industrial sealcoating", "Restaurant lots"],
    neighbors: ["memphis-tn", "covington-tn"],
  },
  {
    slug: "olive-branch-ms",
    city: "Olive Branch",
    state: "MS",
    stateName: "Mississippi",
    county: "DeSoto County",
    population: "≈ 39,000",
    drive: "30 min from Memphis",
    intro:
      "Olive Branch is one of DeSoto County's commercial engines, packed with retail centers, distribution facilities, and growing neighborhoods. We handle warehouse layouts, retail restriping, and HOA sealcoating across the city.",
    landmarks: ["Goodman Road corridor", "Olive Branch Industrial Park", "Olive Branch Airport"],
    services_focus: ["Warehouse striping", "Retail sealcoating", "HOA pavement marking"],
    neighbors: ["southaven-ms", "horn-lake-ms", "collierville-tn", "hernando-ms"],
  },
  {
    slug: "southaven-ms",
    city: "Southaven",
    state: "MS",
    stateName: "Mississippi",
    county: "DeSoto County",
    population: "≈ 56,000",
    drive: "20 min from Memphis",
    intro:
      "Southaven is the largest city in Mississippi north of Jackson and home to dense retail, restaurants, and offices along Goodman Road and I-55. We work overnight and weekends so your business stays open.",
    landmarks: ["Southaven Towne Center", "Snowden Grove", "Tanger Outlets DeSoto"],
    services_focus: ["Big-box retail striping", "Outlet center sealcoating", "Restaurant lots"],
    neighbors: ["horn-lake-ms", "olive-branch-ms", "memphis-tn", "hernando-ms"],
  },
  {
    slug: "horn-lake-ms",
    city: "Horn Lake",
    state: "MS",
    stateName: "Mississippi",
    county: "DeSoto County",
    population: "≈ 27,500",
    drive: "20 min from Memphis",
    intro:
      "Horn Lake's commercial properties along Goodman Road and Highway 51 keep growing. We deliver fast restriping for busy retail lots and full sealcoats for HOA common areas.",
    landmarks: ["Goodman Road", "Highway 51 commercial district"],
    services_focus: ["Apartment complex sealcoating", "Retail restriping", "HOA work"],
    neighbors: ["southaven-ms", "olive-branch-ms", "memphis-tn"],
  },
  {
    slug: "hernando-ms",
    city: "Hernando",
    state: "MS",
    stateName: "Mississippi",
    county: "DeSoto County",
    population: "≈ 17,000",
    drive: "35 min from Memphis",
    intro:
      "Hernando's historic courthouse square and growing commercial belt along I-55 deserve thoughtful pavement work. We provide clean stripe layouts and durable sealcoating for downtown and commercial properties.",
    landmarks: ["Hernando Town Square", "I-55 commercial corridor"],
    services_focus: ["Downtown lot striping", "Office sealcoating", "Church lots"],
    neighbors: ["olive-branch-ms", "southaven-ms", "senatobia-ms"],
  },
  {
    slug: "holly-springs-ms",
    city: "Holly Springs",
    state: "MS",
    stateName: "Mississippi",
    county: "Marshall County",
    population: "≈ 7,500",
    drive: "50 min from Memphis",
    intro:
      "Holly Springs combines historic Mississippi character with practical small-business needs. We deliver affordable, quality striping and sealcoating for downtown shops, churches, and county properties.",
    landmarks: ["Courthouse Square", "Highway 78 corridor"],
    services_focus: ["Small business lots", "Church sealcoating", "County properties"],
    neighbors: ["olive-branch-ms", "senatobia-ms"],
  },
  {
    slug: "senatobia-ms",
    city: "Senatobia",
    state: "MS",
    stateName: "Mississippi",
    county: "Tate County",
    population: "≈ 8,200",
    drive: "45 min from Memphis",
    intro:
      "Senatobia's I-55 commercial properties and downtown businesses get the same Memphis-metro quality at honest small-town pricing. Northwest Mississippi Community College's surrounding businesses keep us busy.",
    landmarks: ["Northwest Mississippi Community College", "I-55 exit business district"],
    services_focus: ["College-area lots", "Small business striping", "Church sealcoating"],
    neighbors: ["hernando-ms", "batesville-ms", "holly-springs-ms"],
  },
  {
    slug: "batesville-ms",
    city: "Batesville",
    state: "MS",
    stateName: "Mississippi",
    county: "Panola County",
    population: "≈ 7,400",
    drive: "60 min from Memphis",
    intro:
      "Batesville sits at the crossroads of I-55 and U.S. 6, making it a hub for distribution and retail in north-central Mississippi. We provide industrial-grade striping for distribution centers and retail restriping for the busy I-55 corridor.",
    landmarks: ["I-55/Highway 6 interchange", "Batesville commercial district"],
    services_focus: ["Distribution-center striping", "Retail sealcoating", "Industrial lots"],
    neighbors: ["senatobia-ms", "oxford-ms"],
  },
  {
    slug: "oxford-ms",
    city: "Oxford",
    state: "MS",
    stateName: "Mississippi",
    county: "Lafayette County",
    population: "≈ 28,000",
    drive: "90 min from Memphis",
    intro:
      "Home to Ole Miss, Oxford's downtown square and the surrounding commercial belt depend on a polished, well-marked parking experience. We work around game-day schedules and student moves to keep your lot ready.",
    landmarks: ["The Square", "University of Mississippi", "Oxford Commons"],
    services_focus: ["Restaurant lots", "University-area striping", "Retail sealcoating"],
    neighbors: ["batesville-ms", "senatobia-ms"],
  },
  {
    slug: "west-memphis-ar",
    city: "West Memphis",
    state: "AR",
    stateName: "Arkansas",
    county: "Crittenden County",
    population: "≈ 24,000",
    drive: "15 min from Memphis",
    intro:
      "Just across the Mississippi River, West Memphis is a logistics powerhouse with major truck-stop, distribution, and retail facilities along I-40 and I-55. We deliver industrial-grade striping and sealcoating that holds up to constant heavy traffic.",
    landmarks: ["Southland Casino Hotel", "I-40/I-55 interchange", "Industrial corridor"],
    services_focus: ["Truck-stop striping", "Distribution-center sealcoating", "Retail lots"],
    neighbors: ["marion-ar", "memphis-tn"],
  },
  {
    slug: "marion-ar",
    city: "Marion",
    state: "AR",
    stateName: "Arkansas",
    county: "Crittenden County",
    population: "≈ 13,000",
    drive: "20 min from Memphis",
    intro:
      "Marion's I-55 commercial corridor and growing retail strip keep our crews busy with everything from new layouts to ongoing maintenance. We service the entire eastern Arkansas commercial belt.",
    landmarks: ["I-55 exits", "Marion city center"],
    services_focus: ["Retail striping", "HOA sealcoating", "Small business lots"],
    neighbors: ["west-memphis-ar", "memphis-tn"],
  },
];

export const CITIES_BY_SLUG = Object.fromEntries(CITIES.map((c) => [c.slug, c]));
